import { CommentModel } from '@modules/comment/comment-model';

const { fields } = CommentModel;

export default [
  fields.admin,
  fields.comment,
  fields.status,
];
